var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createSuper");

var _toConsumableArray = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/slicedToArray");

/*! For license information please see bundle.js.LICENSE.txt */
!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e(require("react"), require("react-dom")) : "function" == typeof define && define.amd ? define(["react", "react-dom"], e) : "object" == typeof exports ? exports["calliope-blockworld"] = e(require("react"), require("react-dom")) : t["calliope-blockworld"] = e(t.react, t["react-dom"]);
}(self, function (t, e) {
  return function () {
    var n = {
      524: function _(t, e, n) {
        var r = {
          "./AIR.jsx": 920,
          "./BEDROCK.jsx": 243,
          "./BOOKCASE.jsx": 220,
          "./BRICK.jsx": 402,
          "./COBBLESTONE.jsx": 798,
          "./CONCRETE.jsx": 1,
          "./DIAMOND.jsx": 987,
          "./DIRT.jsx": 830,
          "./GLASS.jsx": 888,
          "./GOLD.jsx": 657,
          "./GRAVEL.jsx": 151,
          "./IRON.jsx": 296,
          "./LAVA.jsx": 726,
          "./OBSIDIAN.jsx": 41,
          "./PLANK.jsx": 623,
          "./SAND.jsx": 391,
          "./SPONGE.jsx": 684,
          "./TNT.jsx": 645,
          "./WOOD.jsx": 42
        };

        function o(t) {
          var e = i(t);
          return n(e);
        }

        function i(t) {
          if (!n.o(r, t)) {
            var e = new Error("Cannot find module '" + t + "'");
            throw e.code = "MODULE_NOT_FOUND", e;
          }

          return r[t];
        }

        o.keys = function () {
          return Object.keys(r);
        }, o.resolve = i, t.exports = o, o.id = 524;
      },
      920: function _(t, e, n) {
        "use strict";

        n.r(e), n.d(e, {
          default: function _default() {
            return r;
          }
        });
        var r = {
          id: 0,
          spawnable: !1,
          selflit: !1,
          gravity: !1,
          fluid: !1,
          transparent: !0
        };
      },
      243: function _(t, e, n) {
        "use strict";

        n.r(e), n.d(e, {
          default: function _default() {
            return r;
          }
        });
        var r = {
          id: 1,
          spawnable: !1,
          selflit: !1,
          gravity: !1,
          fluid: !1,
          transparent: !1,
          texture: function texture(t, e, n, r, o, i, a) {
            return [1 / 16, 1 / 16, 2 / 16, 2 / 16];
          }
        };
      },
      220: function _(t, e, n) {
        "use strict";

        n.r(e), n.d(e, {
          default: function _default() {
            return o;
          }
        });
        var r = n(967);
        var o = {
          id: 5,
          spawnable: !0,
          transparent: !1,
          selflit: !1,
          gravity: !1,
          fluid: !1,
          texture: function texture(t, e, n, o, i, a, s) {
            return s === r.J.FORWARD || s === r.J.BACK ? [3 / 16, 2 / 16, .25, 3 / 16] : [.25, 0, 5 / 16, 1 / 16];
          }
        };
      },
      402: function _(t, e, n) {
        "use strict";

        n.r(e), n.d(e, {
          default: function _default() {
            return r;
          }
        });
        var r = {
          id: 10,
          spawnable: !0,
          transparent: !1,
          selflit: !1,
          gravity: !1,
          fluid: !1,
          texture: function texture(t, e, n, r, o, i, a) {
            return [7 / 16, 0, .5, 1 / 16];
          }
        };
      },
      798: function _(t, e, n) {
        "use strict";

        n.r(e), n.d(e, {
          default: function _default() {
            return r;
          }
        });
        var r = {
          id: 8,
          spawnable: !0,
          transparent: !1,
          selflit: !1,
          gravity: !1,
          fluid: !1,
          texture: function texture(t, e, n, r, o, i, a) {
            return [0, 1 / 16, 1 / 16, 2 / 16];
          }
        };
      },
      1: function _(t, e, n) {
        "use strict";

        n.r(e), n.d(e, {
          default: function _default() {
            return r;
          }
        });
        var r = {
          id: 9,
          spawnable: !0,
          transparent: !1,
          selflit: !1,
          gravity: !1,
          fluid: !1,
          texture: function texture(t, e, n, r, o, i, a) {
            return [1 / 16, 0, 2 / 16, 1 / 16];
          }
        };
      },
      987: function _(t, e, n) {
        "use strict";

        n.r(e), n.d(e, {
          default: function _default() {
            return r;
          }
        });
        var r = {
          id: 15,
          spawnable: !0,
          transparent: !1,
          selflit: !1,
          gravity: !1,
          fluid: !1,
          texture: function texture(t, e, n, r, o, i, a) {
            return [.5, 1 / 16, 9 / 16, 2 / 16];
          }
        };
      },
      830: function _(t, e, n) {
        "use strict";

        n.r(e), n.d(e, {
          default: function _default() {
            return o;
          }
        });
        var r = n(967);
        var o = {
          id: 2,
          spawnable: !0,
          transparent: !1,
          selflit: !1,
          gravity: !1,
          fluid: !1,
          texture: function texture(t, e, n, o, i, a, s) {
            return s == r.J.UP && n ? [.875, 0, 15 / 16, 1 / 16] : s != r.J.DOWN && n ? [3 / 16, 0, .25, 1 / 16] : [2 / 16, 0, 3 / 16, 1 / 16];
          }
        };
      },
      888: function _(t, e, n) {
        "use strict";

        n.r(e), n.d(e, {
          default: function _default() {
            return r;
          }
        });
        var r = {
          id: 17,
          spawnable: !0,
          transparent: !0,
          selflit: !1,
          gravity: !1,
          fluid: !1,
          texture: function texture(t, e, n, r, o, i, a) {
            return [1 / 16, 3 / 16, 2 / 16, .25];
          }
        };
      },
      657: function _(t, e, n) {
        "use strict";

        n.r(e), n.d(e, {
          default: function _default() {
            return r;
          }
        });
        var r = {
          id: 14,
          spawnable: !0,
          transparent: !1,
          selflit: !1,
          gravity: !1,
          fluid: !1,
          texture: function texture(t, e, n, r, o, i, a) {
            return [7 / 16, 1 / 16, .5, 2 / 16];
          }
        };
      },
      151: function _(t, e, n) {
        "use strict";

        n.r(e), n.d(e, {
          default: function _default() {
            return r;
          }
        });
        var r = {
          id: 12,
          spawnable: !0,
          transparent: !1,
          selflit: !1,
          gravity: !0,
          fluid: !1,
          texture: function texture(t, e, n, r, o, i, a) {
            return [3 / 16, 1 / 16, .25, 2 / 16];
          }
        };
      },
      296: function _(t, e, n) {
        "use strict";

        n.r(e), n.d(e, {
          default: function _default() {
            return r;
          }
        });
        var r = {
          id: 13,
          spawnable: !0,
          transparent: !1,
          selflit: !1,
          gravity: !1,
          fluid: !1,
          texture: function texture(t, e, n, r, o, i, a) {
            return [6 / 16, 1 / 16, 7 / 16, 2 / 16];
          }
        };
      },
      726: function _(t, e, n) {
        "use strict";

        n.r(e), n.d(e, {
          default: function _default() {
            return r;
          }
        });
        var r = {
          id: 6,
          spawnable: !1,
          transparent: !0,
          selflit: !0,
          gravity: !0,
          fluid: !0,
          texture: function texture(t, e, n, r, o, i, a) {
            return [13 / 16, .875, .875, 15 / 16];
          }
        };
      },
      41: function _(t, e, n) {
        "use strict";

        n.r(e), n.d(e, {
          default: function _default() {
            return r;
          }
        });
        var r = {
          id: 16,
          spawnable: !0,
          transparent: !1,
          selflit: !1,
          gravity: !1,
          fluid: !1,
          texture: function texture(t, e, n, r, o, i, a) {
            return [5 / 16, 2 / 16, 6 / 16, 3 / 16];
          }
        };
      },
      623: function _(t, e, n) {
        "use strict";

        n.r(e), n.d(e, {
          default: function _default() {
            return r;
          }
        });
        var r = {
          id: 7,
          spawnable: !0,
          transparent: !1,
          selflit: !1,
          gravity: !1,
          fluid: !1,
          texture: function texture(t, e, n, r, o, i, a) {
            return [.25, 0, 5 / 16, 1 / 16];
          }
        };
      },
      391: function _(t, e, n) {
        "use strict";

        n.r(e), n.d(e, {
          default: function _default() {
            return r;
          }
        });
        var r = {
          id: 11,
          spawnable: !0,
          transparent: !1,
          selflit: !1,
          gravity: !0,
          fluid: !1,
          texture: function texture(t, e, n, r, o, i, a) {
            return [2 / 16, 1 / 16, 3 / 16, 2 / 16];
          }
        };
      },
      684: function _(t, e, n) {
        "use strict";

        n.r(e), n.d(e, {
          default: function _default() {
            return r;
          }
        });
        var r = {
          id: 18,
          spawnable: !0,
          transparent: !1,
          selflit: !1,
          gravity: !1,
          fluid: !1,
          texture: function texture(t, e, n, r, o, i, a) {
            return [0, 3 / 16, 1 / 16, .25];
          }
        };
      },
      645: function _(t, e, n) {
        "use strict";

        n.r(e), n.d(e, {
          default: function _default() {
            return o;
          }
        });
        var r = n(967);
        var o = {
          id: 4,
          spawnable: !0,
          transparent: !1,
          selflit: !1,
          gravity: !1,
          fluid: !1,
          texture: function texture(t, e, n, o, i, a, s) {
            return s === r.J.UP || s === r.J.DOWN ? [.625, 0, 11 / 16, 1 / 16] : [.5, 0, 9 / 16, 1 / 16];
          }
        };
      },
      42: function _(t, e, n) {
        "use strict";

        n.r(e), n.d(e, {
          default: function _default() {
            return o;
          }
        });
        var r = n(967);
        var o = {
          id: 3,
          spawnable: !0,
          transparent: !1,
          selflit: !1,
          gravity: !1,
          fluid: !1,
          texture: function texture(t, e, n, o, i, a, s) {
            return s === r.J.UP || s === r.J.DOWN ? [5 / 16, 1 / 16, 6 / 16, 2 / 16] : [.25, 1 / 16, 5 / 16, 2 / 16];
          }
        };
      },
      967: function _(t, e, n) {
        "use strict";

        n.d(e, {
          R: function R() {
            return r;
          },
          J: function J() {
            return o;
          }
        });
        var r = {
          DOWN: 1,
          UP: 2,
          MOVE: 3
        },
            o = {
          UP: 1,
          DOWN: 2,
          LEFT: 3,
          RIGHT: 4,
          FORWARD: 5,
          BACK: 6
        };
      },
      953: function _(t, e, n) {
        "use strict";

        n.d(e, {
          Z: function Z() {
            return A;
          }
        });
        var r = n(537),
            o = n.n(r),
            i = n(879),
            a = n.n(i),
            s = n(667),
            c = n.n(s),
            u = new URL(n(833), n.b),
            l = new URL(n(11), n.b),
            f = new URL(n(563), n.b),
            p = a()(o()),
            h = c()(u),
            d = c()(l),
            y = c()(f);
        p.push([t.id, "/*                                                 *** ----------------------------------------------- **\n**             Calliope - Site Generator   \t       **\n** ----------------------------------------------- **\n**  Copyright (c) 2020-2021 - Kyle Derby MacInnis  **\n**                                                 **\n**    Any unauthorized distribution or transfer    **\n**       of this work is strictly prohibited.      **\n**                                                 **\n**               All Rights Reserved.              **\n** ----------------------------------------------- **\n\\*                                                 */\n@font-face {\n    font-family: minecraftia;\n    src: url(" + h + "); }\n  \n  .bitworld {\n    background: url(" + d + ");\n    font-family: minecraftia;\n    font-size: 16px;\n    height: 400px;\n    text-shadow: #3f3f3f 2px 2px 0px;\n    position: relative;\n    padding: 2.5em;\n    align-items: center;\n    align-content: center; }\n  \n  .renderSurface {\n    height: 100%;\n    left: 0;\n    position: absolute;\n    top: 0;\n    width: 100%; }\n  \n  .materialSelector {\n    background: rgba(0, 0, 0, 0.6);\n    margin: auto;\n    position: relative; }\n    .materialSelector tr {\n      height: 70px; }\n    .materialSelector td {\n      background-position: 0px 0px;\n      background: url(" + y + ");\n      cursor: pointer;\n      margin: 0;\n      opacity: 0.3;\n      padding: 0;\n      width: 70px; }\n      .materialSelector td:hover {\n        opacity: 0.8; }\n  \n  .nickname {\n    color: #ffffff;\n    cursor: default;\n    left: 42%;\n    position: absolute;\n    top: 40%;\n    width: 300px; }\n    .nickname input {\n      background: none;\n      border-bottom: 1px solid #888888;\n      border: none;\n      color: white;\n      font-family: minecraftia;\n      font-size: 24px;\n      outline: none;\n      width: 100%; }\n  \n  .joininfo {\n    color: #ffffff;\n    cursor: default;\n    font-size: 24px;\n    position: absolute;\n    text-align: center;\n    top: 42%;\n    width: 99%; }\n  \n  .chatbox {\n    background: rgba(0, 0, 0, 0.6);\n    bottom: 55px;\n    color: white;\n    cursor: default;\n    height: 195px;\n    left: 20px;\n    overflow: hidden;\n    padding-left: 10px;\n    padding-right: 10px;\n    position: absolute;\n    width: 600px; }\n  \n  .chatbox_text {\n    bottom: 8px;\n    position: absolute;\n    text-shadow: none; }\n  \n  .chatbox_entry {\n    background: rgba(0, 0, 0, 0.6);\n    border: none;\n    bottom: 18px;\n    color: white;\n    font-family: minecraftia;\n    font-size: 16px;\n    height: 30px;\n    left: 20px;\n    outline: none;\n    padding-bottom: 2px;\n    padding-left: 10px;\n    position: absolute;\n    width: 610px; }\n  ", "", {
          version: 3,
          sources: ["webpack://./css/bitworld.css"],
          names: [],
          mappings: "AAAA;;;;;;;;;;oDAUoD;AACpD;IACI,wBAAwB;IACxB,4CAAqC,EAAE;;EAEzC;IACE,mDAAiD;IACjD,wBAAwB;IACxB,eAAe;IACf,aAAa;IACb,gCAAgC;IAChC,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,qBAAqB,EAAE;;EAEzB;IACE,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,MAAM;IACN,WAAW,EAAE;;EAEf;IACE,8BAA8B;IAC9B,YAAY;IACZ,kBAAkB,EAAE;IACpB;MACE,YAAY,EAAE;IAChB;MACE,4BAA4B;MAC5B,mDAAkD;MAClD,eAAe;MACf,SAAS;MACT,YAAY;MACZ,UAAU;MACV,WAAW,EAAE;MACb;QACE,YAAY,EAAE;;EAEpB;IACE,cAAc;IACd,eAAe;IACf,SAAS;IACT,kBAAkB;IAClB,QAAQ;IACR,YAAY,EAAE;IACd;MACE,gBAAgB;MAChB,gCAAgC;MAChC,YAAY;MACZ,YAAY;MACZ,wBAAwB;MACxB,eAAe;MACf,aAAa;MACb,WAAW,EAAE;;EAEjB;IACE,cAAc;IACd,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,UAAU,EAAE;;EAEd;IACE,8BAA8B;IAC9B,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,aAAa;IACb,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY,EAAE;;EAEhB;IACE,WAAW;IACX,kBAAkB;IAClB,iBAAiB,EAAE;;EAErB;IACE,8BAA8B;IAC9B,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,wBAAwB;IACxB,eAAe;IACf,YAAY;IACZ,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,YAAY,EAAE",
          sourcesContent: ['/*                                                 *** ----------------------------------------------- **\n**             Calliope - Site Generator   \t       **\n** ----------------------------------------------- **\n**  Copyright (c) 2020-2021 - Kyle Derby MacInnis  **\n**                                                 **\n**    Any unauthorized distribution or transfer    **\n**       of this work is strictly prohibited.      **\n**                                                 **\n**               All Rights Reserved.              **\n** ----------------------------------------------- **\n\\*                                                 */\n@font-face {\n    font-family: minecraftia;\n    src: url("../assets/minecraftia.ttf"); }\n  \n  .bitworld {\n    background: url("../assets/media/background.png");\n    font-family: minecraftia;\n    font-size: 16px;\n    height: 400px;\n    text-shadow: #3f3f3f 2px 2px 0px;\n    position: relative;\n    padding: 2.5em;\n    align-items: center;\n    align-content: center; }\n  \n  .renderSurface {\n    height: 100%;\n    left: 0;\n    position: absolute;\n    top: 0;\n    width: 100%; }\n  \n  .materialSelector {\n    background: rgba(0, 0, 0, 0.6);\n    margin: auto;\n    position: relative; }\n    .materialSelector tr {\n      height: 70px; }\n    .materialSelector td {\n      background-position: 0px 0px;\n      background: url("../assets/media/blockthumbs.png");\n      cursor: pointer;\n      margin: 0;\n      opacity: 0.3;\n      padding: 0;\n      width: 70px; }\n      .materialSelector td:hover {\n        opacity: 0.8; }\n  \n  .nickname {\n    color: #ffffff;\n    cursor: default;\n    left: 42%;\n    position: absolute;\n    top: 40%;\n    width: 300px; }\n    .nickname input {\n      background: none;\n      border-bottom: 1px solid #888888;\n      border: none;\n      color: white;\n      font-family: minecraftia;\n      font-size: 24px;\n      outline: none;\n      width: 100%; }\n  \n  .joininfo {\n    color: #ffffff;\n    cursor: default;\n    font-size: 24px;\n    position: absolute;\n    text-align: center;\n    top: 42%;\n    width: 99%; }\n  \n  .chatbox {\n    background: rgba(0, 0, 0, 0.6);\n    bottom: 55px;\n    color: white;\n    cursor: default;\n    height: 195px;\n    left: 20px;\n    overflow: hidden;\n    padding-left: 10px;\n    padding-right: 10px;\n    position: absolute;\n    width: 600px; }\n  \n  .chatbox_text {\n    bottom: 8px;\n    position: absolute;\n    text-shadow: none; }\n  \n  .chatbox_entry {\n    background: rgba(0, 0, 0, 0.6);\n    border: none;\n    bottom: 18px;\n    color: white;\n    font-family: minecraftia;\n    font-size: 16px;\n    height: 30px;\n    left: 20px;\n    outline: none;\n    padding-bottom: 2px;\n    padding-left: 10px;\n    position: absolute;\n    width: 610px; }\n  '],
          sourceRoot: ""
        }]);
        var A = p;
      },
      879: function _(t) {
        "use strict";

        t.exports = function (t) {
          var e = [];
          return e.toString = function () {
            return this.map(function (e) {
              var n = "",
                  r = void 0 !== e[5];
              return e[4] && (n += "@supports (".concat(e[4], ") {")), e[2] && (n += "@media ".concat(e[2], " {")), r && (n += "@layer".concat(e[5].length > 0 ? " ".concat(e[5]) : "", " {")), n += t(e), r && (n += "}"), e[2] && (n += "}"), e[4] && (n += "}"), n;
            }).join("");
          }, e.i = function (t, n, r, o, i) {
            "string" == typeof t && (t = [[null, t, void 0]]);
            var a = {};
            if (r) for (var s = 0; s < this.length; s++) {
              var c = this[s][0];
              null != c && (a[c] = !0);
            }

            for (var u = 0; u < t.length; u++) {
              var l = [].concat(t[u]);
              r && a[l[0]] || (void 0 !== i && (void 0 === l[5] || (l[1] = "@layer".concat(l[5].length > 0 ? " ".concat(l[5]) : "", " {").concat(l[1], "}")), l[5] = i), n && (l[2] ? (l[1] = "@media ".concat(l[2], " {").concat(l[1], "}"), l[2] = n) : l[2] = n), o && (l[4] ? (l[1] = "@supports (".concat(l[4], ") {").concat(l[1], "}"), l[4] = o) : l[4] = "".concat(o)), e.push(l));
            }
          }, e;
        };
      },
      667: function _(t) {
        "use strict";

        t.exports = function (t, e) {
          return e || (e = {}), t ? (t = String(t.__esModule ? t.default : t), /^['"].*['"]$/.test(t) && (t = t.slice(1, -1)), e.hash && (t += e.hash), /["'() \t\n]|(%20)/.test(t) || e.needQuotes ? '"'.concat(t.replace(/"/g, '\\"').replace(/\n/g, "\\n"), '"') : t) : t;
        };
      },
      537: function _(t) {
        "use strict";

        t.exports = function (t) {
          var e = t[1],
              n = t[3];
          if (!n) return e;

          if ("function" == typeof btoa) {
            var r = btoa(unescape(encodeURIComponent(JSON.stringify(n)))),
                o = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(r),
                i = "/*# ".concat(o, " */"),
                a = n.sources.map(function (t) {
              return "/*# sourceURL=".concat(n.sourceRoot || "").concat(t, " */");
            });
            return [e].concat(a).concat([i]).join("\n");
          }

          return [e].join("\n");
        };
      },
      679: function _(t, e, n) {
        "use strict";

        var r = n(864),
            o = {
          childContextTypes: !0,
          contextType: !0,
          contextTypes: !0,
          defaultProps: !0,
          displayName: !0,
          getDefaultProps: !0,
          getDerivedStateFromError: !0,
          getDerivedStateFromProps: !0,
          mixins: !0,
          propTypes: !0,
          type: !0
        },
            i = {
          name: !0,
          length: !0,
          prototype: !0,
          caller: !0,
          callee: !0,
          arguments: !0,
          arity: !0
        },
            a = {
          $$typeof: !0,
          compare: !0,
          defaultProps: !0,
          displayName: !0,
          propTypes: !0,
          type: !0
        },
            s = {};

        function c(t) {
          return r.isMemo(t) ? a : s[t.$$typeof] || o;
        }

        s[r.ForwardRef] = {
          $$typeof: !0,
          render: !0,
          defaultProps: !0,
          displayName: !0,
          propTypes: !0
        }, s[r.Memo] = a;
        var u = Object.defineProperty,
            l = Object.getOwnPropertyNames,
            f = Object.getOwnPropertySymbols,
            p = Object.getOwnPropertyDescriptor,
            h = Object.getPrototypeOf,
            d = Object.prototype;

        t.exports = function t(e, n, r) {
          if ("string" != typeof n) {
            if (d) {
              var o = h(n);
              o && o !== d && t(e, o, r);
            }

            var a = l(n);
            f && (a = a.concat(f(n)));

            for (var s = c(e), y = c(n), A = 0; A < a.length; ++A) {
              var g = a[A];

              if (!(i[g] || r && r[g] || y && y[g] || s && s[g])) {
                var v = p(n, g);

                try {
                  u(e, g, v);
                } catch (t) {}
              }
            }
          }

          return e;
        };
      },
      703: function _(t, e, n) {
        "use strict";

        var r = n(414);

        function o() {}

        function i() {}

        i.resetWarningCache = o, t.exports = function () {
          function t(t, e, n, o, i, a) {
            if (a !== r) {
              var s = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
              throw s.name = "Invariant Violation", s;
            }
          }

          function e() {
            return t;
          }

          t.isRequired = t;
          var n = {
            array: t,
            bool: t,
            func: t,
            number: t,
            object: t,
            string: t,
            symbol: t,
            any: t,
            arrayOf: e,
            element: t,
            elementType: t,
            instanceOf: e,
            node: t,
            objectOf: e,
            oneOf: e,
            oneOfType: e,
            shape: e,
            exact: e,
            checkPropTypes: i,
            resetWarningCache: o
          };
          return n.PropTypes = n, n;
        };
      },
      697: function _(t, e, n) {
        t.exports = n(703)();
      },
      414: function _(t) {
        "use strict";

        t.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
      },
      921: function _(t, e) {
        "use strict";

        var n = "function" == typeof Symbol && Symbol.for,
            r = n ? Symbol.for("react.element") : 60103,
            o = n ? Symbol.for("react.portal") : 60106,
            i = n ? Symbol.for("react.fragment") : 60107,
            a = n ? Symbol.for("react.strict_mode") : 60108,
            s = n ? Symbol.for("react.profiler") : 60114,
            c = n ? Symbol.for("react.provider") : 60109,
            u = n ? Symbol.for("react.context") : 60110,
            l = n ? Symbol.for("react.async_mode") : 60111,
            f = n ? Symbol.for("react.concurrent_mode") : 60111,
            p = n ? Symbol.for("react.forward_ref") : 60112,
            h = n ? Symbol.for("react.suspense") : 60113,
            d = n ? Symbol.for("react.suspense_list") : 60120,
            y = n ? Symbol.for("react.memo") : 60115,
            A = n ? Symbol.for("react.lazy") : 60116,
            g = n ? Symbol.for("react.block") : 60121,
            v = n ? Symbol.for("react.fundamental") : 60117,
            b = n ? Symbol.for("react.responder") : 60118,
            m = n ? Symbol.for("react.scope") : 60119;

        function x(t) {
          if ("object" == typeof t && null !== t) {
            var e = t.$$typeof;

            switch (e) {
              case r:
                switch (t = t.type) {
                  case l:
                  case f:
                  case i:
                  case s:
                  case a:
                  case h:
                    return t;

                  default:
                    switch (t = t && t.$$typeof) {
                      case u:
                      case p:
                      case A:
                      case y:
                      case c:
                        return t;

                      default:
                        return e;
                    }

                }

              case o:
                return e;
            }
          }
        }

        function w(t) {
          return x(t) === f;
        }

        e.AsyncMode = l, e.ConcurrentMode = f, e.ContextConsumer = u, e.ContextProvider = c, e.Element = r, e.ForwardRef = p, e.Fragment = i, e.Lazy = A, e.Memo = y, e.Portal = o, e.Profiler = s, e.StrictMode = a, e.Suspense = h, e.isAsyncMode = function (t) {
          return w(t) || x(t) === l;
        }, e.isConcurrentMode = w, e.isContextConsumer = function (t) {
          return x(t) === u;
        }, e.isContextProvider = function (t) {
          return x(t) === c;
        }, e.isElement = function (t) {
          return "object" == typeof t && null !== t && t.$$typeof === r;
        }, e.isForwardRef = function (t) {
          return x(t) === p;
        }, e.isFragment = function (t) {
          return x(t) === i;
        }, e.isLazy = function (t) {
          return x(t) === A;
        }, e.isMemo = function (t) {
          return x(t) === y;
        }, e.isPortal = function (t) {
          return x(t) === o;
        }, e.isProfiler = function (t) {
          return x(t) === s;
        }, e.isStrictMode = function (t) {
          return x(t) === a;
        }, e.isSuspense = function (t) {
          return x(t) === h;
        }, e.isValidElementType = function (t) {
          return "string" == typeof t || "function" == typeof t || t === i || t === f || t === s || t === a || t === h || t === d || "object" == typeof t && null !== t && (t.$$typeof === A || t.$$typeof === y || t.$$typeof === c || t.$$typeof === u || t.$$typeof === p || t.$$typeof === v || t.$$typeof === b || t.$$typeof === m || t.$$typeof === g);
        }, e.typeOf = x;
      },
      864: function _(t, e, n) {
        "use strict";

        t.exports = n(921);
      },
      872: function _(t, e, n) {
        "use strict";

        n.d(e, {
          collect: function collect() {
            return J;
          }
        });

        var r = {
          currentComponent: null,
          isBatchUpdating: !1,
          isInBrowser: "undefined" != typeof window,
          listeners: new Map(),
          manualListeners: [],
          nextVersionMap: new WeakMap(),
          proxyIsMuted: !1,
          redirectToNext: !0,
          store: {}
        },
            o = Symbol("PATH"),
            i = Symbol("ORIGINAL"),
            a = "RR_DEBUG",
            s = function s(t) {
          return !!t && "object" == typeof t && t.constructor === Object;
        },
            c = function c(t) {
          return Array.isArray(t);
        },
            u = function u(t) {
          return t instanceof Map;
        },
            l = function l(t) {
          return t instanceof Set;
        },
            f = function f(t) {
          return s(t) || c(t) || u(t) || l(t);
        },
            p = function p(t) {
          return t === o || "constructor" === t || "toJSON" === t || "@@toStringTag" === t || t === Symbol.toStringTag;
        },
            h = function h(t) {
          return "function" == typeof t;
        },
            d = function d(t) {
          return s(t) ? Object.assign({}, t) : c(t) ? t.slice() : u(t) ? new Map(t) : l(t) ? new Set(t) : t;
        },
            y = function y(t, e) {
          return u(t) ? t.get(e) : l(t) ? e : (c(t), t[e]);
        },
            A = function A(t, e, n) {
          if (s(t)) t[e] = n;else if (c(t)) t[e] = n;else if (u(t)) t.set(e, n);else {
            if (!l(t)) throw Error("Unexpected type");
            t.add(n);
          }
        },
            g = function g(t) {
          if (s(t)) return Object.keys(t).length;
          if (c(t)) return t.length;
          if (u(t) || l(t)) return t.size;
          throw Error("Unexpected type");
        },
            v = function v(t, e) {
          var n = [],
              r = function r(t) {
            var o = e(t, n.slice()),
                i = void 0 !== o ? o : t,
                a = function a(t, e) {
              n.push(t);
              var o = r(e);
              n.pop(), A(i, t, o);
            };

            if (s(i)) Object.entries(i).forEach(function (_ref) {
              var _ref2 = _slicedToArray(_ref, 2),
                  t = _ref2[0],
                  e = _ref2[1];

              a(t, e);
            });else if (c(i) || u(i)) i.forEach(function (t, e) {
              a(e, t);
            });else if (l(i)) {
              var _t = Array.from(i);

              i.clear(), _t.forEach(function (t) {
                a(t, t);
              });
            }
            return i;
          };

          return r(t);
        },
            b = function b(t) {
          r.proxyIsMuted = !0;
          var e = t();
          return r.proxyIsMuted = !1, e;
        },
            m = function m(t, e) {
          return t.map(function (t) {
            return t.toString();
          }).join(e);
        },
            x = function x(t) {
          return m(t, ".");
        },
            w = function w(t) {
          return m(t, "~~~");
        },
            E = function E(t, e) {
          var n = t[o] || [];
          return void 0 === e ? n : n.concat(e);
        },
            R = function R(t, e) {
          return x(E(t, e));
        },
            T = function T(t, e) {
          t && Object.defineProperty(t, o, {
            value: e,
            writable: !0
          });
        },
            C = function C(t) {
          return t[o] || [];
        },
            I = "undefined" != typeof window && !!window.localStorage,
            S = function S(t, e) {
          if (I) try {
            var _n = "string" == typeof e ? e : JSON.stringify(e);

            return localStorage.setItem(t, _n);
          } catch (t) {
            return;
          }
        },
            M = "on",
            B = "off";

        var k = function (t) {
          if (!I) return;
          var e = localStorage.getItem("RR_DEBUG");
          if (!e) return e;

          try {
            return JSON.parse(e);
          } catch (t) {
            return e;
          }
        }() || B;

        k === M && console.info("Recollect debugging is enabled. Type __RR__.debugOff() to turn it off.");

        var _ = function _(t) {
          k === M && t();
        },
            P = function P(t, e, n) {
          _(function () {
            console.groupCollapsed("GET: ".concat(R(t, e))), console.info("Component: <".concat(r.currentComponent._name, ">")), void 0 !== n && console.info("Value:", n), console.groupEnd();
          });
        },
            O = function O(t, e, n) {
          _(function () {
            console.groupCollapsed("SET: ".concat(R(t, e))), console.info("From:", y(t, e)), console.info("To:  ", n), console.groupEnd();
          });
        },
            D = {},
            U = function U(t) {
          return D.UpdateNextStore(t);
        },
            F = function F(t) {
          if (!r.currentComponent) return;
          var e = w(t),
              n = r.listeners.get(e) || new Set();
          n.add(r.currentComponent), r.listeners.set(e, n);
        },
            z = function z(t) {
          return new Proxy(t, u(e = t) || l(e) ? {
            get: function get(t, e) {
              if (e === i) return t;
              var n = Reflect.get(t, e);
              if (h(n) && (n = n.bind(t)), r.proxyIsMuted || p(e)) return n;

              if (!r.currentComponent && r.redirectToNext) {
                var _n2 = r.nextVersionMap.get(t);

                if (_n2) return Reflect.get(_n2, e);
              }

              return "set" === e ? new Proxy(n, {
                apply: function apply(n, r, _ref3) {
                  var _ref4 = _slicedToArray(_ref3, 2),
                      o = _ref4[0],
                      i = _ref4[1];

                  return r.get(o) === i || U({
                    target: r,
                    prop: o,
                    value: i,
                    updater: function updater(n, r) {
                      return O(t, e, r), Reflect.apply(n[e], n, [o, r]);
                    }
                  });
                }
              }) : "add" === e ? new Proxy(n, {
                apply: function apply(n, r, _ref5) {
                  var _ref6 = _slicedToArray(_ref5, 1),
                      o = _ref6[0];

                  return !!r.has(o) || U({
                    target: r,
                    notifyTarget: !0,
                    value: o,
                    updater: function updater(n, r) {
                      return O(t, e, r), Reflect.apply(n[e], n, [r]);
                    }
                  });
                }
              }) : "clear" === e || "delete" === e ? new Proxy(n, {
                apply: function apply(n, r, _ref7) {
                  var _ref8 = _slicedToArray(_ref7, 1),
                      o = _ref8[0];

                  return !(!r.size || "delete" === e && !r.has(o)) && U({
                    target: r,
                    notifyTarget: !0,
                    updater: function updater(n) {
                      return O(t, e), Reflect.apply(n[e], n, [o]);
                    }
                  });
                }
              }) : r.currentComponent && u(t) && "get" === e ? new Proxy(n, {
                apply: function apply(e, n, r) {
                  return F(E(t, r[0])), Reflect.apply(e, n, r);
                }
              }) : n;
            }
          } : {
            get: function get(t, e) {
              if (e === i) return t;
              var n = Reflect.get(t, e);
              if (r.proxyIsMuted || p(e)) return n;
              if (function (t, e) {
                return c(t) && ["copyWithin", "fill", "pop", "push", "reverse", "shift", "sort", "splice", "unshift"].includes(e);
              }(t, e)) return new Proxy(n, {
                apply: function apply(n, r, o) {
                  return U({
                    target: r,
                    notifyTarget: !0,
                    value: o,
                    updater: function updater(n, r) {
                      O(t, e, r);
                      var o = Reflect.apply(n[e], n, r),
                          i = C(t);
                      return v(n, function (t, e) {
                        f(t) && T(t, [].concat(_toConsumableArray(i), _toConsumableArray(e)));
                      }), o;
                    }
                  });
                }
              });
              if (h(t[e])) return n;
              if (r.currentComponent) c(t) && "length" === e || (P(t, e, n), F(E(t, e)));else if (r.redirectToNext) {
                var _n3 = r.nextVersionMap.get(t);

                if (_n3) return Reflect.get(_n3, e);
              }
              return n;
            },
            has: function has(t, e) {
              var n = Reflect.has(t, e);
              if (r.proxyIsMuted || p(e)) return n;
              if (r.currentComponent) c(t) || (P(t, e), F(E(t, e)));else {
                var _n4 = r.nextVersionMap.get(t);

                if (_n4) return Reflect.has(_n4, e);
              }
              return n;
            },
            ownKeys: function ownKeys(t) {
              var e = Reflect.ownKeys(t);
              if (r.proxyIsMuted) return e;
              if (r.currentComponent) P(t), F(C(t));else {
                var _e = r.nextVersionMap.get(t);

                if (_e) return Reflect.ownKeys(_e);
              }
              return e;
            },
            set: function set(t, e, n) {
              return r.proxyIsMuted ? Reflect.set(t, e, n) : t[e] === n || U({
                target: t,
                prop: e,
                value: n,
                updater: function updater(n, r) {
                  return O(t, e, r), Reflect.set(n, e, r);
                }
              });
            },
            deleteProperty: function deleteProperty(t, e) {
              return r.proxyIsMuted ? Reflect.deleteProperty(t, e) : U({
                target: t,
                prop: e,
                notifyTarget: !0,
                updater: function updater(n) {
                  return function (t, e) {
                    _(function () {
                      console.groupCollapsed("DELETE: ".concat(R(t, e))), console.info("Property: ", R(t, e)), console.groupEnd();
                    });
                  }(t, e), Reflect.deleteProperty(n, e);
                }
              });
            }
          });
          var e;
        };

        var j = n(111);

        var N = n.n(j)().unstable_batchedUpdates || function (t) {
          t();
        },
            L = {
          components: new Map(),
          changedPaths: new Set()
        };

        var Y;
        r.store = z({}), Y = function Y(_ref9) {
          var t = _ref9.target,
              e = _ref9.prop,
              n = _ref9.value,
              _ref9$notifyTarget = _ref9.notifyTarget,
              o = _ref9$notifyTarget === void 0 ? !1 : _ref9$notifyTarget,
              a = _ref9.updater;
          return b(function () {
            var s;
            var c = C(t),
                u = E(t, e);
            var l = !1;
            var p = g(t);
            var h = n;
            return f(h) && (h = v(n, function (t, e) {
              if (!f(t)) return t;
              var n = d(t);
              return T(n, [].concat(_toConsumableArray(u), _toConsumableArray(e))), z(n);
            })), c.length ? c.reduce(function (e, n, o) {
              var u = y(e, n);
              var f = d(u);
              return T(f, C(u)), f = z(f), A(e, n, f), o === c.length - 1 && (s = a(f, h), l = g(f) !== p, r.nextVersionMap.set(t[i] || t, f)), f;
            }, r.store) : (s = a(r.store, h), l = g(r.store) !== p), function (t) {
              var e = w(t),
                  n = x(t);
              L.changedPaths.add(n), r.listeners.forEach(function (t, r) {
                "" !== e && e !== r || t.forEach(function (t) {
                  var e = L.components.get(t) || new Set();
                  e.add(n), L.components.set(t, e);
                });
              }), r.isBatchUpdating || (N(function () {
                L.components.forEach(function (t, e) {
                  (function (t, e) {
                    _(function () {
                      console.groupCollapsed("UPDATE:  <".concat(t._name, ">")), console.info("Changed properties:", e), console.groupEnd();
                    });
                  })(e, Array.from(t)), e.update();
                });
              }), r.manualListeners.forEach(function (t) {
                return t({
                  changedProps: Array.from(L.changedPaths),
                  renderedComponents: Array.from(L.components.keys()),
                  store: r.store
                });
              }), L.components.clear(), L.changedPaths.clear());
            }(o || l ? c : u), s;
          });
        }, D.UpdateNextStore = Y;
        var W = n(156),
            $ = n.n(W),
            V = n(679),
            G = n.n(V);

        var X = [],
            K = function K() {
          r.isInBrowser && (_(function () {
            console.groupEnd();
          }), X.pop(), r.currentComponent = X[X.length - 1] || null);
        },
            H = function H() {
          return b(function () {
            var t = Object.assign({}, r.store);
            return r.nextVersionMap.set(t, r.store), z(t);
          });
        },
            J = function J(t) {
          var e = t.displayName || t.name || "NamelessComponent";

          var n = /*#__PURE__*/function (_$$PureComponent) {
            _inherits(n, _$$PureComponent);

            var _super = _createSuper(n);

            function n() {
              var _this;

              _classCallCheck(this, n);

              _this = _super.apply(this, arguments), _this.state = {
                store: H()
              }, _this._isMounted = !1, _this._isMounting = !0, _this._isRendering = !1, _this._name = e;
              return _this;
            }

            _createClass(n, [{
              key: "componentDidMount",
              value: function componentDidMount() {
                this._isMounted = !0, this._isMounting = !1, K(), this._isRendering = !1;
              }
            }, {
              key: "componentDidUpdate",
              value: function componentDidUpdate() {
                K(), this._isRendering = !1;
              }
            }, {
              key: "componentWillUnmount",
              value: function componentWillUnmount() {
                var t;
                t = this, r.listeners.forEach(function (e, _n5) {
                  var o = Array.from(e).filter(function (e) {
                    return e !== t;
                  });
                  o.length ? r.listeners.set(_n5, new Set(o)) : r.listeners.delete(_n5);
                }), this._isMounted = !1;
              }
            }, {
              key: "update",
              value: function update() {
                (this._isMounted || this._isMounting) && this.setState({
                  store: H()
                });
              }
            }, {
              key: "render",
              value: function render() {
                var e;
                this._isRendering || (e = this, r.isInBrowser && (_(function () {
                  console.groupCollapsed("RENDER: <".concat(e._name, ">"));
                }), r.currentComponent = e, X.push(r.currentComponent)), this._isRendering = !0);

                var _n6 = Object.assign(Object.assign({}, this.props), {
                  store: this.state.store
                });

                return $().createElement(t, Object.assign({}, _n6));
              }
            }]);

            return n;
          }($().PureComponent);

          return n.displayName = "Collected(".concat(e, ")"), G()(n, t);
        };

        var q;
        q = n(697);
        var Z = r.store;
        "undefined" != typeof window && ("Proxy" in window ? window.__RR__ = {
          debugOn: function debugOn() {
            k = M, S(a, M);
          },
          debugOff: function debugOff() {
            k = B, S(a, B);
          },
          internals: r
        } : console.warn("This browser doesn't support the Proxy object, which react-recollect needs. See https://caniuse.com/#search=proxy to find out which browsers do support it"));
      },
      565: function _(t, e, n) {
        t.exports = n(872);
      },
      379: function _(t) {
        "use strict";

        var e = [];

        function n(t) {
          for (var n = -1, r = 0; r < e.length; r++) {
            if (e[r].identifier === t) {
              n = r;
              break;
            }
          }

          return n;
        }

        function r(t, r) {
          for (var i = {}, a = [], s = 0; s < t.length; s++) {
            var c = t[s],
                u = r.base ? c[0] + r.base : c[0],
                l = i[u] || 0,
                f = "".concat(u, " ").concat(l);
            i[u] = l + 1;
            var p = n(f),
                h = {
              css: c[1],
              media: c[2],
              sourceMap: c[3],
              supports: c[4],
              layer: c[5]
            };
            if (-1 !== p) e[p].references++, e[p].updater(h);else {
              var d = o(h, r);
              r.byIndex = s, e.splice(s, 0, {
                identifier: f,
                updater: d,
                references: 1
              });
            }
            a.push(f);
          }

          return a;
        }

        function o(t, e) {
          var n = e.domAPI(e);
          return n.update(t), function (e) {
            if (e) {
              if (e.css === t.css && e.media === t.media && e.sourceMap === t.sourceMap && e.supports === t.supports && e.layer === t.layer) return;
              n.update(t = e);
            } else n.remove();
          };
        }

        t.exports = function (t, o) {
          var i = r(t = t || [], o = o || {});
          return function (t) {
            t = t || [];

            for (var a = 0; a < i.length; a++) {
              var s = n(i[a]);
              e[s].references--;
            }

            for (var c = r(t, o), u = 0; u < i.length; u++) {
              var l = n(i[u]);
              0 === e[l].references && (e[l].updater(), e.splice(l, 1));
            }

            i = c;
          };
        };
      },
      569: function _(t) {
        "use strict";

        var e = {};

        t.exports = function (t, n) {
          var r = function (t) {
            if (void 0 === e[t]) {
              var n = document.querySelector(t);
              if (window.HTMLIFrameElement && n instanceof window.HTMLIFrameElement) try {
                n = n.contentDocument.head;
              } catch (t) {
                n = null;
              }
              e[t] = n;
            }

            return e[t];
          }(t);

          if (!r) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
          r.appendChild(n);
        };
      },
      216: function _(t) {
        "use strict";

        t.exports = function (t) {
          var e = document.createElement("style");
          return t.setAttributes(e, t.attributes), t.insert(e, t.options), e;
        };
      },
      636: function _(t, e, n) {
        "use strict";

        t.exports = function (t) {
          var e = n.nc;
          e && t.setAttribute("nonce", e);
        };
      },
      795: function _(t) {
        "use strict";

        t.exports = function (t) {
          var e = t.insertStyleElement(t);
          return {
            update: function update(n) {
              !function (t, e, n) {
                var r = "";
                n.supports && (r += "@supports (".concat(n.supports, ") {")), n.media && (r += "@media ".concat(n.media, " {"));
                var o = void 0 !== n.layer;
                o && (r += "@layer".concat(n.layer.length > 0 ? " ".concat(n.layer) : "", " {")), r += n.css, o && (r += "}"), n.media && (r += "}"), n.supports && (r += "}");
                var i = n.sourceMap;
                i && "undefined" != typeof btoa && (r += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(i)))), " */")), e.styleTagTransform(r, t, e.options);
              }(e, t, n);
            },
            remove: function remove() {
              !function (t) {
                if (null === t.parentNode) return !1;
                t.parentNode.removeChild(t);
              }(e);
            }
          };
        };
      },
      589: function _(t) {
        "use strict";

        t.exports = function (t, e) {
          if (e.styleSheet) e.styleSheet.cssText = t;else {
            for (; e.firstChild;) {
              e.removeChild(e.firstChild);
            }

            e.appendChild(document.createTextNode(t));
          }
        };
      },
      11: function _(t, e, n) {
        "use strict";

        t.exports = n.p + "7f7998869754cfc3cdb3.png";
      },
      563: function _(t, e, n) {
        "use strict";

        t.exports = n.p + "9f8ddbc26dd98d1f0788.png";
      },
      833: function _(t, e, n) {
        "use strict";

        t.exports = n.p + "0e755413bd6e99d762eb.ttf";
      },
      156: function _(e) {
        "use strict";

        e.exports = t;
      },
      111: function _(t) {
        "use strict";

        t.exports = e;
      }
    },
        r = {};

    function o(t) {
      var e = r[t];
      if (void 0 !== e) return e.exports;
      var i = r[t] = {
        id: t,
        exports: {}
      };
      return n[t](i, i.exports, o), i.exports;
    }

    o.m = n, o.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return o.d(e, {
        a: e
      }), e;
    }, o.d = function (t, e) {
      for (var n in e) {
        o.o(e, n) && !o.o(t, n) && Object.defineProperty(t, n, {
          enumerable: !0,
          get: e[n]
        });
      }
    }, o.g = function () {
      if ("object" == typeof globalThis) return globalThis;

      try {
        return this || new Function("return this")();
      } catch (t) {
        if ("object" == typeof window) return window;
      }
    }(), o.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, o.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, function () {
      var t;
      o.g.importScripts && (t = o.g.location + "");
      var e = o.g.document;

      if (!t && e && (e.currentScript && (t = e.currentScript.src), !t)) {
        var n = e.getElementsByTagName("script");
        n.length && (t = n[n.length - 1].src);
      }

      if (!t) throw new Error("Automatic publicPath is not supported in this browser");
      t = t.replace(/#.*$/, "").replace(/\?.*$/, "").replace(/\/[^\/]+$/, "/"), o.p = t;
    }(), o.b = document.baseURI || self.location.href;
    var i = {};
    return function () {
      "use strict";

      o.r(i), o.d(i, {
        default: function _default() {
          return at;
        }
      });
      var t = o(156),
          e = o.n(t),
          n = o(565),
          r = o(697),
          a = o.n(r);

      function s(t, e) {
        return function (t) {
          if (Array.isArray(t)) return t;
        }(t) || function (t, e) {
          var n = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];

          if (null != n) {
            var r,
                o,
                i = [],
                a = !0,
                s = !1;

            try {
              for (n = n.call(t); !(a = (r = n.next()).done) && (i.push(r.value), !e || i.length !== e); a = !0) {
                ;
              }
            } catch (t) {
              s = !0, o = t;
            } finally {
              try {
                a || null == n.return || n.return();
              } finally {
                if (s) throw o;
              }
            }

            return i;
          }
        }(t, e) || function (t, e) {
          if (t) {
            if ("string" == typeof t) return c(t, e);
            var n = Object.prototype.toString.call(t).slice(8, -1);
            return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? c(t, e) : void 0;
          }
        }(t, e) || function () {
          throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
      }

      function c(t, e) {
        (null == e || e > t.length) && (e = t.length);

        for (var n = 0, r = new Array(e); n < e; n++) {
          r[n] = t[n];
        }

        return r;
      }

      var u = function u() {
        var t = new Float32Array(16);
        return t[0] = 1, t[5] = 1, t[10] = 1, t[15] = 1, t;
      },
          l = function l(t, e, n, r) {
        var o = t,
            i = s(r, 3),
            a = i[0],
            c = i[1],
            u = i[2],
            l = Math.hypot(a, c, u);
        if (l < 1e-6) throw new Error("Matrix4*4 rotate has wrong axis");
        a *= l = 1 / l, c *= l, u *= l;

        var f = Math.sin(n),
            p = Math.cos(n),
            h = 1 - p,
            d = s(e, 12),
            y = d[0],
            A = d[1],
            g = d[2],
            v = d[3],
            b = d[4],
            m = d[5],
            x = d[6],
            w = d[7],
            E = d[8],
            R = d[9],
            T = d[10],
            C = d[11],
            I = a * a * h + p,
            S = c * a * h + u * f,
            M = u * a * h - c * f,
            B = a * c * h - u * f,
            k = c * c * h + p,
            _ = u * c * h + a * f,
            P = a * u * h + c * f,
            O = c * u * h - a * f,
            D = u * u * h + p;

        return o[0] = y * I + b * S + E * M, o[1] = A * I + m * S + R * M, o[2] = g * I + x * S + T * M, o[3] = v * I + w * S + C * M, o[4] = y * B + b * k + E * _, o[5] = A * B + m * k + R * _, o[6] = g * B + x * k + T * _, o[7] = v * B + w * k + C * _, o[8] = y * P + b * O + E * D, o[9] = A * P + m * O + R * D, o[10] = g * P + x * O + T * D, o[11] = v * P + w * O + C * D, e !== t && (o[12] = e[12], o[13] = e[13], o[14] = e[14], o[15] = e[15]), o;
      };

      function f(t) {
        return 0 == (t & t - 1);
      }

      function p(t, e) {
        for (var n = 0; n < e.length; n++) {
          var r = e[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
        }
      }

      var h = function () {
        function t(e, n, r) {
          var o,
              i,
              a = this;
          !function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, t), i = function i(t, e) {
            var n = e.vs,
                r = e.fs,
                o = a.loadShader(t, t.VERTEX_SHADER, n),
                i = a.loadShader(t, t.FRAGMENT_SHADER, r),
                s = t.createProgram();
            if (t.attachShader(s, o), t.attachShader(s, i), t.linkProgram(s), !t.getProgramParameter(s, t.LINK_STATUS)) throw new Error("WebGL unable to initialize the shader program: ".concat(t.getProgramInfoLog(s)));
            return t.useProgram(s), a.programInfo = {
              program: s,
              attribLocations: {
                aPos: t.getAttribLocation(s, "aPos"),
                aColor: t.getAttribLocation(s, "aColor"),
                aTexCoord: t.getAttribLocation(s, "aTexCoord")
              },
              uniformLocations: {
                uProjMat: t.getUniformLocation(s, "uProjMatrix"),
                uModelMat: t.getUniformLocation(s, "uModelMatrix"),
                uViewMat: t.getUniformLocation(s, "uViewMatrix"),
                uSampler: t.getUniformLocation(s, "uSampler")
              }
            }, t.enableVertexAttribArray(a.programInfo.attribLocations.aPos), t.enableVertexAttribArray(a.programInfo.attribLocations.aColor), t.enableVertexAttribArray(a.programInfo.attribLocations.aTexCoord), s;
          }, (o = "initShaderProgram") in this ? Object.defineProperty(this, o, {
            value: i,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : this[o] = i, this.canvas = e, this.width = n, this.height = r;
        }

        var e, n;
        return e = t, (n = [{
          key: "init",
          value: function value(t) {
            var e = this.canvas.getContext("webgl");
            if (!e) throw new Error("WebGL : unable to initialize");
            this.gl = e, this.scene = t, e.clearColor(0, 0, 0, 1), e.clearDepth(1), e.enable(e.DEPTH_TEST), e.depthFunc(e.LEQUAL), e.blendFunc(e.SRC_ALPHA, e.ONE_MINUS_SRC_ALPHA), this.initShaderProgram(e, t.shaders), this.initProjection(e), this.modelMatrix = u(), e.uniformMatrix4fv(this.programInfo.uniformLocations.uModelMat, !1, this.modelMatrix), t.init(this), this.render = this.render.bind(this), this.requestId = requestAnimationFrame(this.render);
          }
        }, {
          key: "loadShader",
          value: function value(t, e, n) {
            var r = t.createShader(e);

            if (t.shaderSource(r, n), t.compileShader(r), !t.getShaderParameter(r, t.COMPILE_STATUS)) {
              var o = t.getShaderInfoLog(r);
              throw t.deleteShader(r), new Error("An error occurred compiling the shaders: ".concat(o));
            }

            return r;
          }
        }, {
          key: "initProjection",
          value: function value(t) {
            var e = 60 * Math.PI / 180,
                n = t.canvas.clientWidth / t.canvas.clientHeight;
            this.uProjMat = function (t, e, n, r) {
              var o = new Float32Array(16),
                  i = 1 / Math.tan(t / 2);
              o[0] = i / e, o[1] = 0, o[2] = 0, o[3] = 0, o[4] = 0, o[5] = i, o[6] = 0, o[7] = 0, o[8] = 0, o[9] = 0, o[10] = -1, o[11] = -1, o[12] = 0, o[13] = 0, o[14] = -.2, o[15] = 0;
              var a = 1 / -199.9;
              return o[10] = 200.1 * a, o[14] = 40 * a, o;
            }(e, n), t.uniformMatrix4fv(this.programInfo.uniformLocations.uProjMat, !1, this.uProjMat);
          }
        }, {
          key: "setCamera",
          value: function value(t, e) {
            var n,
                r,
                o,
                i,
                a,
                c,
                f,
                p,
                h,
                d,
                y,
                A,
                g,
                v,
                b,
                m,
                x,
                w,
                E,
                R,
                T = this.gl;
            this.camPos = t, this.uViewMat = u(), l(this.uViewMat, this.uViewMat, -e[0] - Math.PI / 2, [1, 0, 0]), l(this.uViewMat, this.uViewMat, e[1], [0, 0, 1]), l(this.uViewMat, this.uViewMat, -e[2], [0, 1, 0]), n = this.uViewMat, r = this.uViewMat, o = n, a = (i = s([-t[0], -t[1], -t[2]], 3))[0], c = i[1], f = i[2], h = (p = s(r, 12))[0], d = p[1], y = p[2], A = p[3], g = p[4], v = p[5], b = p[6], m = p[7], x = p[8], w = p[9], E = p[10], R = p[11], n !== r && (o[0] = h, o[1] = d, o[2] = y, o[3] = A, o[4] = g, o[5] = v, o[6] = b, o[7] = m, o[8] = x, o[9] = w, o[10] = E, o[11] = R), o[12] = h * a + g * c + x * f + r[12], o[13] = d * a + v * c + w * f + r[13], o[14] = y * a + b * c + E * f + r[14], o[15] = A * a + m * c + R * f + r[15], T.uniformMatrix4fv(this.programInfo.uniformLocations.uViewMat, !1, this.uViewMat);
          }
        }, {
          key: "clearScreen",
          value: function value() {
            var t = this.gl;
            t.clear(t.COLOR_BUFFER_BIT | t.DEPTH_BUFFER_BIT);
          }
        }, {
          key: "render",
          value: function value(t) {
            this.scene.render(this, t), requestAnimationFrame(this.render);
          }
        }, {
          key: "buildBuffers",
          value: function value(t) {
            var e = t.positions,
                n = t.colors,
                r = t.indices,
                o = t.aTexCoordinates,
                i = this.gl,
                a = i.createBuffer();
            i.bindBuffer(i.ARRAY_BUFFER, a), i.bufferData(i.ARRAY_BUFFER, new Float32Array(e), i.STATIC_DRAW);
            var s = i.createBuffer();
            i.bindBuffer(i.ARRAY_BUFFER, s), i.bufferData(i.ARRAY_BUFFER, new Float32Array(n), i.STATIC_DRAW);
            var c = i.createBuffer();
            i.bindBuffer(i.ARRAY_BUFFER, c), i.bufferData(i.ARRAY_BUFFER, new Float32Array(o), i.STATIC_DRAW);
            var u = i.createBuffer();
            i.bindBuffer(i.ELEMENT_ARRAY_BUFFER, u), i.bufferData(i.ELEMENT_ARRAY_BUFFER, new Uint16Array(r), i.STATIC_DRAW), this.buffers = {
              position: a,
              color: s,
              texture: c,
              index: u
            };
          }
        }, {
          key: "drawBuffer",
          value: function value(t) {
            var e = this.gl;
            e.bindBuffer(e.ARRAY_BUFFER, t), e.vertexAttribPointer(this.programInfo.attribLocations.aPos, 3, e.FLOAT, !1, 36, 0), e.vertexAttribPointer(this.programInfo.attribLocations.aColor, 4, e.FLOAT, !1, 36, 20), e.vertexAttribPointer(this.programInfo.attribLocations.aTexCoord, 2, e.FLOAT, !1, 36, 12), e.drawArrays(e.TRIANGLES, 0, t.vertices);
          }
        }, {
          key: "loadTexture",
          value: function value(t) {
            var e = this.gl,
                n = e.createTexture();
            e.bindTexture(e.TEXTURE_2D, n);
            var r = new Uint8Array([0, 0, 255, 255]);
            e.texImage2D(e.TEXTURE_2D, 0, e.RGBA, 1, 1, 0, e.RGBA, e.UNSIGNED_BYTE, r);
            var o = new Image();
            return o.onload = function () {
              e.bindTexture(e.TEXTURE_2D, n), e.texImage2D(e.TEXTURE_2D, 0, e.RGBA, e.RGBA, e.UNSIGNED_BYTE, o), f(o.width) && f(o.height) ? e.generateMipmap(e.TEXTURE_2D) : (e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_S, e.CLAMP_TO_EDGE), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_T, e.CLAMP_TO_EDGE), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MIN_FILTER, e.LINEAR));
            }, o.src = t, n;
          }
        }, {
          key: "blankTexture",
          value: function value(t, e) {
            var n = this.gl,
                r = n.createTexture();
            n.activeTexture(e), n.bindTexture(n.TEXTURE_2D, r);
            var o = new Uint8Array(t);
            return n.texImage2D(n.TEXTURE_2D, 0, n.RGBA, 1, 1, 0, n.RGBA, n.UNSIGNED_BYTE, o), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MAG_FILTER, n.NEAREST), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MIN_FILTER, n.NEAREST), n.uniform1i(this.programInfo.uniformLocations.uSampler, e), r;
          }
        }, {
          key: "close",
          value: function value() {
            cancelAnimationFrame(this.requestId);
          }
        }]) && p(e.prototype, n), t;
      }(),
          d = function d(n) {
        var r = n.width,
            o = n.height,
            i = n.SceneProvider,
            a = n.class,
            s = (0, t.useRef)(),
            c = function c() {
          return null;
        },
            u = function u() {
          return null;
        };

        return (0, t.useEffect)(function () {
          var t = s.current,
              e = new h(t, r, o);
          return e.init(i), c = i.onMouseEvent, u = i.onKeyEvent, function () {
            e.close();
          };
        }, [i]), e().createElement("canvas", {
          tabIndex: 0,
          ref: s,
          width: r,
          height: o,
          className: a,
          onKeyDownCapture: function onKeyDownCapture(t) {
            return u(t.key, !0, t);
          },
          onKeyUpCapture: function onKeyUpCapture(t) {
            return u(t.key, !1, t);
          },
          onContextMenu: function onContextMenu(t) {
            return c(t.nativeEvent.clientX, t.nativeEvent.clientY, 2, !0, t);
          },
          onMouseUp: function onMouseUp(t) {
            return c(t.nativeEvent.clientX, t.nativeEvent.clientY, 2, 3 == t.nativeEvent.button, t);
          },
          onMouseDown: function onMouseDown(t) {
            return c(t.nativeEvent.clientX, t.nativeEvent.clientY, 1, 3 == t.nativeEvent.button, t);
          },
          onMouseMove: function onMouseMove(t) {
            return c(t.nativeEvent.clientX, t.nativeEvent.clientY, 3, 3 == t.nativeEvent.button, t);
          }
        });
      };

      d.propTypes = {
        width: a().number.isRequired,
        height: a().number.isRequired,
        SceneProvider: a().object.isRequired,
        class: a().string.isRequired
      };
      var y = d;

      function A(t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }

      function g(t, e) {
        for (var n = 0; n < e.length; n++) {
          var r = e[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
        }
      }

      function v(t, e, n) {
        return e && g(t.prototype, e), n && g(t, n), t;
      }

      var b = function () {
        function t(e, n, r) {
          A(this, t), this.x = e, this.y = n, this.z = r;
        }

        return v(t, [{
          key: "add",
          value: function value(e) {
            return new t(this.x + e.x, this.y + e.y, this.z + e.z);
          }
        }, {
          key: "sub",
          value: function value(e) {
            return new t(this.x - e.x, this.y - e.y, this.z - e.z);
          }
        }, {
          key: "mul",
          value: function value(e) {
            return new t(this.x * e, this.y * e, this.z * e);
          }
        }, {
          key: "length",
          value: function value() {
            return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
          }
        }, {
          key: "distance",
          value: function value(t) {
            return this.sub(t).length();
          }
        }, {
          key: "normal",
          value: function value() {
            if (0 === this.x && 0 === this.y && 0 === this.z) return new t(0, 0, 0);
            var e = this.length();
            return new t(this.x / e, this.y / e, this.z / e);
          }
        }, {
          key: "dot",
          value: function value(t) {
            return this.x * t.x + this.y * t.y + this.z * t.z;
          }
        }, {
          key: "toArray",
          value: function value() {
            return [this.x, this.y, this.z];
          }
        }, {
          key: "toString",
          value: function value() {
            return "( ".concat(this.x, ", ").concat(this.y, ", ").concat(this.z, " )");
          }
        }]), t;
      }(),
          m = function () {
        function t(e, n, r, o) {
          A(this, t), this.x = e, this.y = n, this.z = r, this.w = o;
        }

        return v(t, [{
          key: "add",
          value: function value(e) {
            return new t(this.x + e.x, this.y + e.y, this.z + e.z, this.w + e.w);
          }
        }, {
          key: "sub",
          value: function value(e) {
            return new t(this.x - e.x, this.y - e.y, this.z - e.z, this.w - e.w);
          }
        }, {
          key: "mul",
          value: function value(e) {
            return new t(this.x * e, this.y * e, this.z * e, this.w * e);
          }
        }, {
          key: "length",
          value: function value() {
            return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
          }
        }, {
          key: "distance",
          value: function value(t) {
            return this.sub(t).length();
          }
        }, {
          key: "normal",
          value: function value() {
            if (0 === this.x && 0 === this.y && 0 === this.z && 0 === this.w) return new t(0, 0, 0, 0);
            var e = this.length();
            return new t(this.x / e, this.y / e, this.z / e, this.w / e);
          }
        }, {
          key: "dot",
          value: function value(t) {
            return this.x * t.x + this.y * t.y + this.z * t.z + this.w * t.w;
          }
        }, {
          key: "toArray",
          value: function value() {
            return [this.x, this.y, this.z, this.w];
          }
        }, {
          key: "toString",
          value: function value() {
            return "( ".concat(this.x, ", ").concat(this.y, ", ").concat(this.z, ", ").concat(this.w, " )");
          }
        }]), t;
      }();

      function x(t, e, n, r, o) {
        t.push(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]), t.push(n[0], n[1], n[2], n[3], n[4], n[5], n[6], n[7], n[8]), t.push(r[0], r[1], r[2], r[3], r[4], r[5], r[6], r[7], r[8]), t.push(r[0], r[1], r[2], r[3], r[4], r[5], r[6], r[7], r[8]), t.push(o[0], o[1], o[2], o[3], o[4], o[5], o[6], o[7], o[8]), t.push(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]);
      }

      function w(t) {
        return function (t) {
          if (Array.isArray(t)) return E(t);
        }(t) || function (t) {
          if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
        }(t) || function (t, e) {
          if (t) {
            if ("string" == typeof t) return E(t, e);
            var n = Object.prototype.toString.call(t).slice(8, -1);
            return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? E(t, e) : void 0;
          }
        }(t) || function () {
          throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
      }

      function E(t, e) {
        (null == e || e > t.length) && (e = t.length);

        for (var n = 0, r = new Array(e); n < e; n++) {
          r[n] = t[n];
        }

        return r;
      }

      function R(t, e, n, r) {
        return new m(t, e, n, r);
      }

      function T(t, e, n, r, o) {
        var i = [];
        return {
          positions: [].concat(w(t.toArray()), w(e.toArray()), w(n.toArray()), w(r.toArray())),
          colors: i = i.concat(o.toArray(), o.toArray(), o.toArray(), o.toArray()),
          indices: [0, 1, 2, 0, 2, 3]
        };
      }

      function C(t, e) {
        var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
            r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null,
            o = 0;
        return r && (o = r), t.map(function (t) {
          return t[e];
        }).reduce(function (t, e, r) {
          return [].concat(w(t), w(e.map(function (t) {
            return n ? t + o * r : t;
          })));
        });
      }

      var I = o(967);

      function S(t) {
        return S = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, S(t);
      }

      var M = (B = {
        fromId: function fromId(t) {
          for (var e in B) {
            if ("object" === S(B[e]) && B[e].id === t) return B[e];
          }

          return null;
        },
        pushTop: function pushTop(t, e, n, r, o, i, a) {
          x(t, [e, n, r + o, i[0], i[1], a, a, a, 1], [e + 1, n, r + o, i[2], i[1], a, a, a, 1], [e + 1, n + 1, r + o, i[2], i[3], a, a, a, 1], [e, n + 1, r + o, i[0], i[3], a, a, a, 1]);
        },
        pushFront: function pushFront(t, e, n, r, o, i, a) {
          x(t, [e, n, r, i[0], i[3], a, a, a, 1], [e + 1, n, r, i[2], i[3], a, a, a, 1], [e + 1, n, r + o, i[2], i[1], a, a, a, 1], [e, n, r + o, i[0], i[1], a, a, a, 1]);
        },
        pushBack: function pushBack(t, e, n, r, o, i, a) {
          x(t, [e, n, r + o, i[2], i[1], a, a, a, 1], [e, n + 1, r + o, i[0], i[1], a, a, a, 1], [e, n + 1, r, i[0], i[3], a, a, a, 1], [e, n, r, i[2], i[3], a, a, a, 1]);
        },
        pushBottom: function pushBottom(t, e, n, r, o, i) {
          x(t, [e, n + 1, r, o[0], o[3], i, i, i, 1], [e + 1, n + 1, r, o[2], o[3], i, i, i, 1], [e + 1, n, r, o[2], o[1], i, i, i, 1], [e, n, r, o[0], o[1], i, i, i, 1]);
        },
        pushRight: function pushRight(t, e, n, r, o, i, a) {
          x(t, [e + 1, n, r, i[0], i[3], a, a, a, 1], [e + 1, n + 1, r, i[2], i[3], a, a, a, 1], [e + 1, n + 1, r + o, i[2], i[1], a, a, a, 1], [e + 1, n, r + o, i[0], i[1], a, a, a, 1]);
        },
        pushLeft: function pushLeft(t, e, n, r, o, i, a) {
          x(t, [e, n, r + o, i[2], i[1], a, a, a, 1], [e, n + 1, r + o, i[0], i[1], a, a, a, 1], [e, n + 1, r, i[0], i[3], a, a, a, 1], [e, n, r, i[2], i[3], a, a, a, 1]);
        },
        pushVertices: function pushVertices(t, e, n, r, o, i) {
          var a = e.blocks,
              s = i >= n[r][o],
              c = a[r][o][i],
              u = !c.fluid || i !== e.sz - 1 && a[r][o][i + 1].fluid ? 1 : .9;

          if (i === e.sz - 1 || e.blocks[r][o][i + 1].transparent || c.fluid) {
            var l = c.texture(e, n, s, r, o, i, I.J.UP),
                f = i >= n[r][o] ? 1 : .6;
            c.selflit && (f = 1), B.pushTop(t, r, o, i, u, l, f);
          }

          if (0 === i || e.blocks[r][o][i - 1].transparent) {
            var p = c.texture(e, n, s, r, o, i, I.J.DOWN),
                h = c.selflit ? 1 : .6;
            B.pushBottom(t, r, o, i, p, h);
          }

          if (0 === o || e.blocks[r][o - 1][i].transparent) {
            var d = c.texture(e, n, s, r, o, i, I.J.FORWARD),
                y = 0 === o || i >= n[r][o - 1] ? 1 : .6;
            c.selflit && (y = 1), B.pushFront(t, r, o, i, u, d, y);
          }

          if (o === e.sy - 1 || e.blocks[r][o + 1][i].transparent) {
            var A = c.texture(e, n, s, r, o, i, I.J.BACK),
                g = c.selflit ? 1 : .6;
            B.pushBack(t, r, o, i, u, A, g);
          }

          if (0 === r || e.blocks[r - 1][o][i].transparent) {
            var v = c.texture(e, n, s, r, o, i, I.J.LEFT),
                b = c.selflit ? 1 : .6;
            B.pushLeft(t, r, o, i, u, v, b);
          }

          if (r === e.sx - 1 || e.blocks[r + 1][o][i].transparent) {
            var m = c.texture(e, n, s, r, o, i, I.J.RIGHT);
            console.log(m);
            var x = r === e.sx - 1 || i >= n[r + 1][o] ? 1 : .6;
            c.selflit && (x = 1), B.pushRight(t, r, o, i, u, m, x);
          }
        },
        pushPickingVertices: function pushPickingVertices(t, e, n, r) {
          var o = {
            r: e / 255,
            g: n / 255,
            b: r / 255
          };
          x(t, [e, n, r + 1, 0, 0, o.r, o.g, o.b, 1 / 255], [e + 1, n, r + 1, 1, 0, o.r, o.g, o.b, 1 / 255], [e + 1, n + 1, r + 1, 1, 1, o.r, o.g, o.b, 1 / 255], [e, n + 1, r + 1, 0, 0, o.r, o.g, o.b, 1 / 255]), x(t, [e, n + 1, r, 0, 0, o.r, o.g, o.b, 2 / 255], [e + 1, n + 1, r, 1, 0, o.r, o.g, o.b, 2 / 255], [e + 1, n, r, 1, 1, o.r, o.g, o.b, 2 / 255], [e, n, r, 0, 0, o.r, o.g, o.b, 2 / 255]), x(t, [e, n, r, 0, 0, o.r, o.g, o.b, 3 / 255], [e + 1, n, r, 1, 0, o.r, o.g, o.b, 3 / 255], [e + 1, n, r + 1, 1, 1, o.r, o.g, o.b, 3 / 255], [e, n, r + 1, 0, 0, o.r, o.g, o.b, 3 / 255]), x(t, [e, n + 1, r + 1, 0, 0, o.r, o.g, o.b, 4 / 255], [e + 1, n + 1, r + 1, 1, 0, o.r, o.g, o.b, 4 / 255], [e + 1, n + 1, r, 1, 1, o.r, o.g, o.b, 4 / 255], [e, n + 1, r, 0, 0, o.r, o.g, o.b, 4 / 255]), x(t, [e, n, r + 1, 0, 0, o.r, o.g, o.b, 5 / 255], [e, n + 1, r + 1, 1, 0, o.r, o.g, o.b, 5 / 255], [e, n + 1, r, 1, 1, o.r, o.g, o.b, 5 / 255], [e, n, r, 0, 0, o.r, o.g, o.b, 5 / 255]), x(t, [e + 1, n, r, 0, 0, o.r, o.g, o.b, 6 / 255], [e + 1, n + 1, r, 1, 0, o.r, o.g, o.b, 6 / 255], [e + 1, n + 1, r + 1, 1, 1, o.r, o.g, o.b, 6 / 255], [e + 1, n, r + 1, 0, 0, o.r, o.g, o.b, 6 / 255]);
        }
      }, ["AIR", "DIRT", "BEDROCK", "BOOKCASE", "BRICK", "COBBLESTONE", "CONCRETE", "DIAMOND", "GLASS", "GOLD", "GRAVEL", "LAVA", "OBSIDIAN", "PLANK", "SPONGE", "TNT", "WOOD"].forEach(function (t) {
        B[t] = o(524)("./".concat(t, ".jsx")).default;
      }), B);
      var B;

      function k(t, e) {
        for (var n = 0; n < e.length; n++) {
          var r = e[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
        }
      }

      var _ = function () {
        function t(e, n, r) {
          !function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, t), this.blocks = new Array(e);

          for (var o = 0; o < e; o++) {
            this.blocks[o] = new Array(n);

            for (var i = 0; i < n; i++) {
              this.blocks[o][i] = new Array(r);
            }
          }

          this.sx = e, this.sy = n, this.sz = r, this.players = {};
        }

        var e, n;
        return e = t, n = [{
          key: "createFlatWorld",
          value: function value(t) {
            this.spawnPoint = new b(this.sx / 2 + .5, this.sy / 2 + .5, t);

            for (var e = 0; e < this.sx; e++) {
              for (var n = 0; n < this.sy; n++) {
                for (var r = 0; r < this.sz; r++) {
                  this.blocks[e][n][r] = r < t ? M.DIRT : M.AIR;
                }
              }
            }
          }
        }, {
          key: "createFromString",
          value: function value(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
            this.spawnPoint = e || new b(this.sx / 2 + .5, this.sy / 2 + .5, this.sz);

            for (var n = 0, r = 0; r < this.sx; r++) {
              for (var o = 0; o < this.sy; o++) {
                for (var i = 0; i < this.sz; i++) {
                  this.blocks[r][o][i] = M.fromId(t.charCodeAt(n) - 97), n += 1;
                }
              }
            }
          }
        }, {
          key: "getBlock",
          value: function value(t, e, n) {
            return t < 0 || e < 0 || n < 0 || t > this.sx - 1 || e > this.sy - 1 || n > this.sz - 1 ? M.AIR : this.blocks[t][e][n];
          }
        }, {
          key: "setBlock",
          value: function value(t, e, n, r) {
            this.blocks[t][e][n] = r, null != this.scene && this.scene.onBlockChanged(t, e, n);
          }
        }, {
          key: "toNetworkString",
          value: function value() {
            for (var t = [], e = 0; e < this.sx; e++) {
              for (var n = 0; n < this.sy; n++) {
                for (var r = 0; r < this.sz; r++) {
                  t.push(String.fromCharCode(97 + this.blocks[e][n][r].id));
                }
              }
            }

            return t.join("");
          }
        }, {
          key: "setScene",
          value: function value(t) {
            this.scene = t;
          }
        }], n && k(e.prototype, n), t;
      }();

      function P(t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }

      function O(t, e) {
        for (var n = 0; n < e.length; n++) {
          var r = e[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
        }
      }

      var D = function () {
        function t() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
          P(this, t), this.world = e, this.lastStep = -1;
        }

        var e, n;
        return e = t, (n = [{
          key: "setWorld",
          value: function value(t) {
            this.world = t;
          }
        }, {
          key: "simulate",
          value: function value() {
            var t = this.world,
                e = t.blocks,
                n = Math.floor(new Date().getTime() / 100);

            if (n !== this.lastStep) {
              if (this.lastStep = n, n % 1 == 0) for (var r = 0; r < t.sx; r++) {
                for (var o = 0; o < t.sy; o++) {
                  for (var i = 0; i < t.sz; i++) {
                    e[r][o][i].gravity && i > 0 && e[r][o][i - 1] == M.AIR && (t.setBlock(r, o, i - 1, e[r][o][i]), t.setBlock(r, o, i, M.AIR));
                  }
                }
              }
              if (n % 10 == 0) for (var a = {}, s = 0; s < t.sx; s++) {
                for (var c = 0; c < t.sy; c++) {
                  for (var u = 0; u < t.sz; u++) {
                    var l = e[s][c][u];
                    l.fluid && null == a["".concat(s, ",").concat(c, ",").concat(u)] && (s > 0 && e[s - 1][c][u] == M.AIR && (t.setBlock(s - 1, c, u, l), a["".concat(s - 1, ",").concat(c, ",").concat(u)] = !0), s < t.sx - 1 && e[s + 1][c][u] == M.AIR && (t.setBlock(s + 1, c, u, l), a["".concat(s + 1, ",").concat(c, ",").concat(u)] = !0), c > 0 && e[s][c - 1][u] == M.AIR && (t.setBlock(s, c - 1, u, l), a["".concat(s, ",").concat(c - 1, ",").concat(u)] = !0), c < t.sy - 1 && e[s][c + 1][u] == M.AIR && (t.setBlock(s, c + 1, u, l), a["".concat(s, ",").concat(c + 1, ",").concat(u)] = !0));
                  }
                }
              }
            }
          }
        }]) && O(e.prototype, n), t;
      }();

      function U(t, e) {
        for (var n = 0; n < e.length; n++) {
          var r = e[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
        }
      }

      var F = function () {
        function t(e, n) {
          !function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, t), this.scene = n, this.world = e, this.world.localPlayer = this, this.pos = e.spawnPoint, this.velocity = new b(0, 0, 0), this.angles = [0, Math.PI, 0], this.falling = !1, this.keys = {}, this.buildMaterial = M.DIRT, this.eventHandlers = {};
        }

        var e, n;
        return e = t, (n = [{
          key: "getEyePos",
          value: function value() {
            return this.pos.add(new b(0, 0, 1.7));
          }
        }, {
          key: "update",
          value: function value() {
            var t = this.pos,
                e = this.velocity,
                n = new b(Math.floor(t.x), Math.floor(t.y), Math.floor(t.z));

            if (null != this.lastUpdate) {
              var r = (new Date().getTime() - this.lastUpdate) / 1e3;
              this.dragging && (this.angles[0] += 30 * (this.targetPitch - this.angles[0]) * r, this.angles[1] += 30 * (this.targetYaw - this.angles[1]) * r, this.angles[0] < -Math.PI / 2 && (this.angles[0] = -Math.PI / 2), this.angles[0] > Math.PI / 2 && (this.angles[0] = Math.PI / 2)), this.falling && (e.z += -.5), this.keys[" "] && !this.falling && (e.z = 8);
              var o = new b(0, 0, 0);
              this.falling || (this.keys.w && (o.x += Math.cos(Math.PI / 2 - this.angles[1]), o.y += Math.sin(Math.PI / 2 - this.angles[1])), this.keys.s && (o.x += Math.cos(Math.PI + Math.PI / 2 - this.angles[1]), o.y += Math.sin(Math.PI + Math.PI / 2 - this.angles[1])), this.keys.a && (o.x += Math.cos(Math.PI / 2 + Math.PI / 2 - this.angles[1]), o.y += Math.sin(Math.PI / 2 + Math.PI / 2 - this.angles[1])), this.keys.d && (o.x += Math.cos(-Math.PI / 2 + Math.PI / 2 - this.angles[1]), o.y += Math.sin(-Math.PI / 2 + Math.PI / 2 - this.angles[1]))), o.length() > 0 ? (o = o.normal(), e.x = 4 * o.x, e.y = 4 * o.y) : (e.x /= this.falling ? 1.01 : 1.5, e.y /= this.falling ? 1.01 : 1.5), this.pos = this.resolveCollision(t, n, e.mul(r));
            }

            this.lastUpdate = new Date().getTime();
          }
        }, {
          key: "doBlockAction",
          value: function value(t, e, n) {
            var r = new b(Math.floor(this.pos.x), Math.floor(this.pos.y), Math.floor(this.pos.z)),
                o = this.scene.pickAt(new b(r.x - 4, r.y - 4, r.z - 4), new b(r.x + 4, r.y + 4, r.z + 4), t, e);

            if (0 != o) {
              var i = this.world;
              n ? i.setBlock(o.x, o.y, o.z, M.AIR) : i.setBlock(o.x + o.n.x, o.y + o.n.y, o.z + o.n.z, this.buildMaterial);
            }
          }
        }, {
          key: "onMouseEvent",
          value: function value(t, e, n, r) {
            n == I.R.DOWN ? (this.dragStart = {
              x: t,
              y: e
            }, this.mouseDown = !0, this.yawStart = this.targetYaw = this.angles[1], this.pitchStart = this.targetPitch = this.angles[0]) : n == I.R.UP ? (Math.abs(this.dragStart.x - t) + Math.abs(this.dragStart.y - e) < 4 && this.doBlockAction(t, e, !r), this.dragging = !1, this.mouseDown = !1) : n == I.R.MOVE && this.mouseDown && (this.dragging = !0, this.targetPitch = this.pitchStart - (e - this.dragStart.y) / 200, this.targetYaw = this.yawStart + (t - this.dragStart.x) / 200);
          }
        }, {
          key: "onKeyEvent",
          value: function value(t, e) {
            this.keys[t] = e, !e && "t" == t && this.eventHandlers.openChat && this.eventHandlers.openChat();
          }
        }, {
          key: "resolveCollision",
          value: function value(t, e, n) {
            for (var r, o, i = this.world, a = {
              x: t.x + n.x,
              y: t.y + n.y,
              size: .25
            }, s = [], c = e.x - 1; c <= e.x + 1; c++) {
              for (var u = e.y - 1; u <= e.y + 1; u++) {
                for (var l = e.z; l <= e.z + 1; l++) {
                  i.getBlock(c, u, l) != M.AIR && (i.getBlock(c - 1, u, l) == M.AIR && s.push({
                    x: c,
                    dir: -1,
                    y1: u,
                    y2: u + 1
                  }), i.getBlock(c + 1, u, l) == M.AIR && s.push({
                    x: c + 1,
                    dir: 1,
                    y1: u,
                    y2: u + 1
                  }), i.getBlock(c, u - 1, l) == M.AIR && s.push({
                    y: u,
                    dir: -1,
                    x1: c,
                    x2: c + 1
                  }), i.getBlock(c, u + 1, l) == M.AIR && s.push({
                    y: u + 1,
                    dir: 1,
                    x1: c,
                    x2: c + 1
                  }));
                }
              }
            }

            for (var f in s) {
              var p = s[f];
              (o = a).y > (r = p).y - o.size / 2 && o.y < r.y + o.size / 2 && o.x > r.x1 - o.size / 2 && o.x < r.x2 + o.size / 2 && (null != p.x && n.x * p.dir < 0 ? (t.x = p.x + a.size / 2 * (n.x > 0 ? -1 : 1), n.x = 0) : null != p.y && n.y * p.dir < 0 && (t.y = p.y + a.size / 2 * (n.y > 0 ? -1 : 1), n.y = 0));
            }

            var h,
                d,
                y = {
              x1: t.x + n.x - .125,
              y1: t.y + n.y - .125,
              x2: t.x + n.x + .125,
              y2: t.y + n.y + .125
            },
                A = Math.floor(t.z + n.z),
                g = Math.floor(t.z + 1.7 + 1.1 * n.z);
            s = [];

            for (var v = e.x - 1; v <= e.x + 1; v++) {
              for (var b = e.y - 1; b <= e.y + 1; b++) {
                i.getBlock(v, b, A) != M.AIR && s.push({
                  z: A + 1,
                  dir: 1,
                  x1: v,
                  y1: b,
                  x2: v + 1,
                  y2: b + 1
                }), i.getBlock(v, b, g) != M.AIR && s.push({
                  z: g,
                  dir: -1,
                  x1: v,
                  y1: b,
                  x2: v + 1,
                  y2: b + 1
                });
              }
            }

            for (var m in this.falling = !0, s) {
              var x = s[m];

              if (((d = y).x1 > (h = x).x1 && d.x1 < h.x2 && d.y1 > h.y1 && d.y1 < h.y2 || d.x2 > h.x1 && d.x2 < h.x2 && d.y1 > h.y1 && d.y1 < h.y2 || d.x2 > h.x1 && d.x2 < h.x2 && d.y2 > h.y1 && d.y2 < h.y2 || d.x1 > h.x1 && d.x1 < h.x2 && d.y2 > h.y1 && d.y2 < h.y2) && n.z * x.dir < 0) {
                n.z < 0 ? (this.falling = !1, t.z = x.z, n.z = 0, this.velocity.z = 0) : (t.z = x.z - 1.8, n.z = 0, this.velocity.z = 0);
                break;
              }
            }

            return t.add(n);
          }
        }]) && U(e.prototype, n), t;
      }();

      function z(t, e, n) {
        return e in t ? Object.defineProperty(t, e, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : t[e] = n, t;
      }

      var j = function t() {
        var e,
            n = this;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, t), z(this, "init", function (e) {
          t._instance.engine = e, t._instance.squareRotation = 0, t._instance.from = null;
          var r = t._instance.world = new _(16, 16, 16);
          r.createFlatWorld(6), t._instance.physics = new D(r), t._instance.player = new F(r, t._instance), n.loadTextures(e), n.setWorld(r, 8);
        }), z(this, "buildChunks", function (e) {
          for (var n = t._instance.engine.gl, r = t._instance, o = r.chunks, i = r.world, a = 0; a < o.length; a++) {
            var s = o[a];

            if (s.dirty) {
              for (var c = [], u = {}, l = s.start[0] - 1; l < s.end[0] + 1; l++) {
                u[l] = {};

                for (var f = s.start[1] - 1; f < s.end[1] + 1; f++) {
                  for (var p = i.sz - 1; p >= 0 && (u[l][f] = p, i.getBlock(l, f, p).transparent); p--) {
                    ;
                  }
                }
              }

              for (var h = s.start[0]; h < s.end[0]; h++) {
                for (var d = s.start[1]; d < s.end[1]; d++) {
                  for (var y = s.start[2]; y < s.end[2]; y++) {
                    i.blocks[h][d][y] != M.AIR && M.pushVertices(c, i, u, h, d, y);
                  }
                }
              }

              s.buffer && n.deleteBuffer(s.buffer);
              var A = s.buffer = n.createBuffer();
              A.vertices = c.length / 9, n.bindBuffer(n.ARRAY_BUFFER, A), n.bufferData(n.ARRAY_BUFFER, new Float32Array(c), n.STATIC_DRAW), s.dirty = !1, e--;
            }

            if (0 == e) break;
          }
        }), z(this, "onBlockChanged", function (e, n, r) {
          for (var o = t._instance.chunks, i = 0; i < o.length; i++) {
            (e >= o[i].start[0] && e < o[i].end[0] && n >= o[i].start[1] && n < o[i].end[1] && r >= o[i].start[2] && r < o[i].end[2] || e >= o[i].start[0] && e < o[i].end[0] && n >= o[i].start[1] && n < o[i].end[1] && (r >= o[i].end[2] || r == o[i].start[2] - 1) || e >= o[i].start[0] && e < o[i].end[0] && r >= o[i].start[2] && r < o[i].end[2] && (n == o[i].end[1] || n == o[i].start[1] - 1) || n >= o[i].start[1] && n < o[i].end[1] && r >= o[i].start[2] && r < o[i].end[2] && (e == o[i].end[0] || e == o[i].start[0] - 1)) && (o[i].dirty = !0);
          }
        }), z(this, "setModel", function (e) {
          t._instance.model = e;
        }), z(this, "setWorld", function (e, n) {
          t._instance.world = e, e.setScene(t._instance), t._instance.chunkSize = n;

          for (var r = t._instance.chunks = [], o = 0; o < e.sx; o += n) {
            for (var i = 0; i < e.sy; i += n) {
              for (var a = 0; a < e.sz; a += n) {
                r.push({
                  start: [o, i, a],
                  end: [Math.min(e.sx, o + n), Math.min(e.sy, i + n), Math.min(e.sz, a + n)],
                  dirty: !0
                });
              }
            }
          }
        }), z(this, "loadTextures", function (e) {
          var n = e.gl,
              r = new Uint8Array([255, 255, 255, 255]);
          t._instance.texWhite = e.blankTexture(r, n.TEXTURE0), t._instance.texTerrain = e.loadTexture("media/terrain.png"), t._instance.texPlayer = e.loadTexture("media/player.png");
        }), z(this, "render", function (e, r) {
          t._instance.physics.simulate(), t._instance.player.update(), n.buildChunks(1), e.setCamera(t._instance.player.getEyePos().toArray(), t._instance.player.angles), n.draw(e);
          var o = null === t._instance.from ? 0 : r - t._instance.from;
          t._instance.from = r, t._instance.squareRotation += .001 * o;
        }), z(this, "pickAt", function (e, n, r, o) {
          var i = t._instance,
              a = i.engine,
              s = i.world,
              c = a.gl,
              u = c.createFramebuffer();
          c.bindFramebuffer(c.FRAMEBUFFER, u);
          var l = c.createTexture();
          c.bindTexture(c.TEXTURE_2D, l), c.texParameteri(c.TEXTURE_2D, c.TEXTURE_MAG_FILTER, c.NEAREST), c.texParameteri(c.TEXTURE_2D, c.TEXTURE_MIN_FILTER, c.NEAREST), c.texImage2D(c.TEXTURE_2D, 0, c.RGBA, 512, 512, 0, c.RGBA, c.UNSIGNED_BYTE, null);
          var f = c.createRenderbuffer();
          c.bindRenderbuffer(c.RENDERBUFFER, f), c.renderbufferStorage(c.RENDERBUFFER, c.DEPTH_COMPONENT16, 512, 512), c.framebufferTexture2D(c.FRAMEBUFFER, c.COLOR_ATTACHMENT0, c.TEXTURE_2D, l, 0), c.framebufferRenderbuffer(c.FRAMEBUFFER, c.DEPTH_ATTACHMENT, c.RENDERBUFFER, f);

          for (var p = [], h = e.x; h <= n.x; h++) {
            for (var d = e.y; d <= n.y; d++) {
              for (var y = e.z; y <= n.z; y++) {
                s.getBlock(h, d, y) != M.AIR && M.pushPickingVertices(p, h, d, y);
              }
            }
          }

          var A = c.createBuffer();
          A.vertices = p.length / 9, c.bindBuffer(c.ARRAY_BUFFER, A), c.bufferData(c.ARRAY_BUFFER, new Float32Array(p), c.STREAM_DRAW), c.bindTexture(c.TEXTURE_2D, t._instance.texWhite), c.clear(c.COLOR_BUFFER_BIT | c.DEPTH_BUFFER_BIT), a.drawBuffer(A);
          var g = new Uint8Array(4);

          if (c.readPixels(r / c.viewportWidth * c.viewportWidth, (1 - o / c.viewportHeight) * c.viewportWidth, 1, 1, c.RGBA, c.UNSIGNED_BYTE, g), c.bindTexture(c.TEXTURE_2D, t._instance.texTerrain), c.bindFramebuffer(c.FRAMEBUFFER, null), c.deleteBuffer(A), c.deleteRenderbuffer(f), c.deleteTexture(l), c.deleteFramebuffer(u), 255 != g[0]) {
            console.log(g);
            var v = new b(0, 0, 0);
            return 1 == g[3] ? v = new b(0, 0, 1) : 2 == g[3] ? v = new b(0, 0, -1) : 3 == g[3] ? v = new b(0, -1, 0) : 4 == g[3] ? v = new b(0, 1, 0) : 5 == g[3] ? v = new b(-1, 0, 0) : 6 == g[3] && (v = new b(1, 0, 0)), {
              x: g[0],
              y: g[1],
              z: g[2],
              n: v
            };
          }

          return !1;
        }), z(this, "draw", function (e) {
          var r = e.gl,
              o = e.programInfo;
          e.clearScreen();
          var i = t._instance.chunks;
          if (r.bindTexture(r.TEXTURE_2D, t._instance.texTerrain), null != i) for (var a = 0; a < i.length; a++) {
            null != i[a].buffer && e.drawBuffer(i[a].buffer, n.shaders);
          }
          var s = u();
          r.uniformMatrix4fv(o.attribLocations.uModelMat, !1, s);
        }), z(this, "onKeyEvent", function (e, n) {
          console.log("-----", e), t._instance.player.onKeyEvent(e, n);
        }), z(this, "onMouseEvent", function (e, n, r, o, i) {
          i.preventDefault(), console.log("pos -- ".concat(e, ", ").concat(n), o, i), t._instance.player.onMouseEvent(e, n, r, o);
        }), this.shaders = {
          fs: "\n  precision highp float;\n  uniform sampler2D uSampler;\n  varying vec4 vColor;\n  varying vec2 vTexCoord;\n  void main(void) {\n    vec4 color = texture2D( uSampler, vec2( vTexCoord.s, vTexCoord.t ) ) * vec4( vColor.rgb, 1.0 );\n  \tif ( color.a < 0.1 ) discard;\n  \tgl_FragColor = vec4( color.rgb, vColor.a );\n  }\n",
          vs: "\n  uniform mat4 uModelMatrix;\n  uniform mat4 uViewMatrix;\n  uniform mat4 uProjMatrix;\n\n  attribute vec3 aPos;\n  attribute vec2 aTexCoord;\n  attribute vec4 aColor;\n\n  varying vec4 vColor;\n  varying vec2 vTexCoord;\n\n  void main(void) {\n    gl_Position = uProjMatrix * uViewMatrix * ( uModelMatrix * vec4( aPos, 1.0 ) );\n    vTexCoord = aTexCoord;\n    vColor = vec4(aColor.rgb, 1.0);\n  }\n"
        }, this.model = (e = new Array(5).fill(0).map(function (t, e) {
          return function (t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
                n = t.x,
                r = t.y,
                o = t.z,
                i = T(new b(n - 1, r - 1, o + 1), new b(n + 1, r - 1, o + 1), new b(n + 1, r + 1, o + 1), new b(n - 1, r + 1, o + 1), e || R(.1, 1, 1, 1)),
                a = T(new b(n - 1, r - 1, o - 1), new b(n - 1, r + 1, o - 1), new b(n + 1, r + 1, o - 1), new b(n + 1, r - 1, o - 1), e || R(1, .1, 1, 1)),
                s = T(new b(n - 1, r + 1, o - 1), new b(n - 1, r + 1, o + 1), new b(n + 1, r + 1, o + 1), new b(n + 1, r + 1, o - 1), e || R(1, 1, 1, 1)),
                c = T(new b(n - 1, r - 1, o - 1), new b(n + 1, r - 1, o - 1), new b(n + 1, r - 1, o + 1), new b(n - 1, r - 1, o + 1), e || R(.5, 1, .1, 1)),
                u = T(new b(n + 1, r - 1, o - 1), new b(n + 1, r + 1, o - 1), new b(n + 1, r + 1, o + 1), new b(n + 1, r - 1, o + 1), e || R(1, .5, .1, 1)),
                l = T(new b(n - 1, r - 1, o - 1), new b(n - 1, r - 1, o + 1), new b(n - 1, r + 1, o + 1), new b(n - 1, r + 1, o - 1), e || R(.5, 1, 1, 1)),
                f = [i, a, s, c, u, l];
            return {
              positions: C(f, "positions"),
              colors: C(f, "colors"),
              indices: C(f, "indices", !0, 4)
            };
          }(new b(2 * e, 2 * e, 3 * e));
        }), {
          positions: C(e, "positions"),
          colors: C(e, "colors"),
          indices: C(e, "indices", !0, 24)
        }), t._instance || (t._instance = this), t._instance;
      },
          N = o(379),
          L = o.n(N),
          Y = o(795),
          W = o.n(Y),
          $ = o(569),
          V = o.n($),
          G = o(636),
          X = o.n(G),
          K = o(216),
          H = o.n(K),
          J = o(589),
          q = o.n(J),
          Z = o(953),
          Q = {};

      function tt(t) {
        return tt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, tt(t);
      }

      function et(t, e) {
        for (var n = 0; n < e.length; n++) {
          var r = e[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
        }
      }

      function nt(t, e) {
        return nt = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, nt(t, e);
      }

      function rt(t, e) {
        if (e && ("object" === tt(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return function (t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }(t);
      }

      function ot(t) {
        return ot = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, ot(t);
      }

      Q.styleTagTransform = q(), Q.setAttributes = X(), Q.insert = V().bind(null, "head"), Q.domAPI = W(), Q.insertStyleElement = H(), L()(Z.Z, Q), Z.Z && Z.Z.locals && Z.Z.locals;

      var it = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && nt(t, e);
        }(s, t);
        var n,
            r,
            o,
            i,
            a = (o = s, i = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = ot(o);

          if (i) {
            var n = ot(this).constructor;
            t = Reflect.construct(e, arguments, n);
          } else t = e.apply(this, arguments);

          return rt(this, t);
        });

        function s(t) {
          var e;
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, s), (e = a.call(this, t)).state = {
            networkString: t.networkString,
            updated: Date.now()
          }, e;
        }

        return n = s, (r = [{
          key: "componentWillReceiveProps",
          value: function value(t) {
            console.log(t), JSON.stringify(this.props.networkString) != JSON.stringify(t.networkString) && this.setState({
              networkString: t.networkString,
              updated: Date.now()
            });
          }
        }, {
          key: "render",
          value: function value() {
            var t = this.state,
                n = t.networkString,
                r = t.updated;
            return e().createElement(e().Fragment, null, e().createElement(y, {
              class: "bitworld",
              key: r,
              width: 720,
              height: 480,
              SceneProvider: new j(),
              networkString: n
            }));
          }
        }]) && et(n.prototype, r), s;
      }(t.Component);

      var at = (0, n.collect)(it);
    }(), i;
  }();
});